export enum sizeOptions {
  sm = "sm",
  lg = "lg",
}

export enum variantOptions {
  soft = "soft",
  strong = "strong",
}
